import axios from "axios";
import store from "../redux/store";
import { logout } from "../redux/slices/authSlice";

console.log("API BASE URL:", process.env.REACT_APP_API_URL);

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// 🔍 REQUEST DEBUG
api.interceptors.request.use(
  (req) => {
    const token = localStorage.getItem("token");
    console.log("➡️ API REQUEST:", req.method?.toUpperCase(), req.url);
    console.log("➡️ TOKEN:", token);

    if (token) {
      req.headers.Authorization = `Bearer ${token}`;
    }

    console.log("➡️ HEADERS:", req.headers);
    console.log("➡️ BODY:", req.data);

    return req;
  },
  (error) => {
    console.error("❌ REQUEST ERROR:", error);
    return Promise.reject(error);
  },
);

// 🔍 RESPONSE DEBUG
api.interceptors.response.use(
  (res) => {
    console.log("✅ API RESPONSE:", res.config.url, res.data);
    return res;
  },
  (err) => {
    console.error("❌ API ERROR:", err.response?.status, err.response?.data);

    if (err.response?.status === 401) {
      console.warn("⚠️ 401 Unauthorized – logging out");
      store.dispatch(logout());
      window.location.href = "/login";
    }

    return Promise.reject(err);
  },
);

export default api;
